import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	addPriorityHeader: {
		id: 'admin-pages-priorities.priority-sidebars.add-priority-header',
		defaultMessage: 'Add priority',
		description: 'Modal header for adding a priority',
	},
	editPriorityHeader: {
		id: 'admin-pages-priorities.priority-sidebars.edit-priority-header',
		defaultMessage: 'Edit priority',
		description: 'Modal header for editing a priority',
	},
	addPriorityButton: {
		id: 'admin-pages-priorities.priority-sidebars.add-priority-button',
		defaultMessage: 'Add priority',
		description: 'Primary call to action button in the modal to add a priority',
	},
	editPriorityButton: {
		id: 'admin-pages-priorities.priority-sidebars.edit-priority-button',
		defaultMessage: 'Edit priority',
		description: 'Primary call to action button in the modal to add a priority',
	},
});
